import { render, staticRenderFns } from "./Holidays.vue?vue&type=template&id=7c536066&scoped=true"
import script from "./Holidays.vue?vue&type=script&lang=ts"
export * from "./Holidays.vue?vue&type=script&lang=ts"
import style0 from "./Holidays.vue?vue&type=style&index=0&id=7c536066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c536066",
  null
  
)

export default component.exports